import * as React from 'react';
import ISmallPriceChart, { TSmallPriceChart } from './ISmallPriceChart';
import { IFilteredTradesList } from '../TradeHistory/ITradeHistory';
import Chart from 'react-apexcharts';
import moment from 'moment';
import Big from 'big.js';

import * as style from './SmallPriceChartStyle.module.scss'
const big = Big();

export default class SmallPriceChart extends React.Component<ISmallPriceChart, TSmallPriceChart> {
  constructor(props: ISmallPriceChart) {
    super(props);
    const generatedDates = this.generateDates();
    const chartData = this.getLineChartData(this.props.tradesList, generatedDates);

    this.state = {
      options: {
        chart: {
          toolbar: { show: false }, zoom: { enabled: false },
          sparkline: { enabled: true },
          animations: { enabled: false },
        },
        colors: [this.props.color || '#ffffff'],
        stroke: { width: 1 },
        tooltip: {
          enabled: false,
        },
      },
      series: [{
        name: 'Price chart',
        data: chartData,
      }],
    };
  }

  generateDates = () => {
    const firstDate = moment();
    const dates = [];

    for (let i = 7; i >= 0; i -= 1) {
      dates.push(moment(firstDate).subtract(i, 'days').format('YYYY-MM-DD'));
    }

    return dates;
  }

  getLineChartData = (data: IFilteredTradesList[], generatedDates: string[]) => {
    type obj = { date: string; number_of_shares: number; value: number };
    const initialValue = this.getLineChartInitialValue(generatedDates[0]);
    const lineChartData: number[] = [];

    const reducedData = data.reduce((prev: obj[], current: obj, index: number) => {
      const lastItem = prev.length - 1;
      if (index !== 0 && prev[lastItem].date === current.date) {
        prev[lastItem] = {
          date: current.date,
          number_of_shares: Number(big(prev[lastItem].number_of_shares).add(current.number_of_shares)),
          value:  Number(big(prev[lastItem].value).add(current.value)),
        };
        return prev;
      }

      prev.push({ date: current.date, number_of_shares: current.number_of_shares, value: current.value });
      return prev;
    }, []);

    generatedDates.forEach((date: string, i: number) => {
      const isInArray = reducedData.find((el: obj) => el.date === date);
      if (isInArray) {
        lineChartData.push(Number(big(isInArray.value).div(isInArray.number_of_shares)));
      } else {
        lineChartData.push(lineChartData[i - 1] || initialValue);
      }
    });

    return lineChartData;
  }

  getLineChartInitialValue = (startDate: string) => {
    let lastFilledTrades = undefined;
    const lastFilledTrade = this.props.tradesList.find((el: IFilteredTradesList) =>
      el.value !== 0 && moment(el.date).isBefore(startDate));

    if (lastFilledTrade) {
      lastFilledTrades = this.props.tradesList.filter((el: IFilteredTradesList) => el.date === lastFilledTrade.date);
    }

    if (lastFilledTrades) {
      const reduced = lastFilledTrades.reduce((prev: IFilteredTradesList, current: IFilteredTradesList) => {
        return {
          ...current,
          number_of_shares: Number(big(prev.number_of_shares).add(current.number_of_shares)),
          value:  Number(big(prev.value).add(current.value)),
        };
      });

      return Number(big(reduced.value).div(reduced.number_of_shares));
    }

    return 0;
  }

  getPercentageChange = (data: number[]) => {
    let value = '100%';

    if (data[0] !== 0) {
      value = `${(100 - Number(big(data[data.length - 1]).div(data[0]).times(100).toFixed(0))) * -1}%`;
    } else if (data[data.length - 1] === 0) {
      value = '0%';
    }

    return `${(value.charAt(0) !== '-' && value.charAt(0) !== '0') ? '+' : ''}${value}`;
  }

  render() {
    const percentageValue = this.getPercentageChange(this.state.series[0].data);
    const className = percentageValue.charAt(0) === '-' ? 'Red' : 'Green';

    return (
      <>
        {!this.props.hidePercentage &&
          <span className={[style.value, style[`value${className}`]].join(' ')}>{percentageValue}</span>
        }
        <div>
          <Chart
            options={this.state.options}
            series={this.state.series}
            type="line"
            width={this.props.width || 50}
            height={this.props.height || 20}
          />
        </div>
      </>
    );
  }
}
